// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"4f4b69f2","292":"99b00af1","453":"d7c6c495","551":"fbebda42","842":"f4b6e9ba"}[chunkId] + ".chunk.js";
};